import { render } from "./ContentSlider.vue?vue&type=template&id=6f985f5d&scoped=true"
import script from "./ContentSlider.vue?vue&type=script&lang=js"
export * from "./ContentSlider.vue?vue&type=script&lang=js"

import "./ContentSlider.vue?vue&type=style&index=0&id=6f985f5d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f985f5d"]])

export default __exports__